/** @jsx jsx */

import { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import isIE from 'services/isIE';
import getBlockById from 'services/apiHelpers/getBlockById';


const IELayout = interactionContext => {
  return isIE()
    ? {
      Row: ({ children, ...props }) => {
        return (
          <div
            css={css`
                display: flex;
              `}
          >
            {children}
          </div>
        );
      },
      Column: ({ children, ...props }) => {
        const context = useContext(interactionContext);

        const testBorder = children.length === 1 ? 'lightBlue' : 'lime';

        const block = getBlockById(props.id);
        const isButtonBlock =
          block && block.meta && block.meta.subType === 'ButtonBlock';

        return (
          <div
            css={css`
            display: flex;
            ${isButtonBlock &&
              `
              justify-content: center;
              flex-wrap: wrap;
              `}
            align-items: center;
            width: 100%;

           
            padding: 8px;
            

          `}
          >
            {children}
          </div>
        );
      },
      TwoColumnLayout: ({ children }) => {
        return (
          <div
            css={css`
                display: flex;
              `}
          >
            {children}
          </div>
        );
      },
      SingleColumnLayout: ({ children }) => {
        return (
          <div
            css={css`
                display: flex;
                flex-direction: column;
                width: 100%;

                ${children.length > 1 && 'height: auto;'}

                .chameleon-text {
                  width: 100%;

                  * {
                    width: 100%;
                  }
                }
              `}
          >
            {children}
          </div>
        );
      },
    }
    : {};
};

export default IELayout;
